import * as React from "react";

import "./previous-order-select.scss";

import {Link,
        makeChain} from "@Common/react/cst2";
import {Types}     from "@Common/types";
import {Select}    from "@Common/ui-components/heavy/common/design2/select/select";


export const PreviousOrderSelect = ({
    selectedOrderId,
    orders,
    useShortOrderName         = true,
    placeholderAsOption       = false,
    optionsWidthAsFieldWidth  = false,
    onApplyOrderChange,
}:{
    selectedOrderId           : number,
    orders                    : Types.Apis.Models.GalleryOrder[],
    useShortOrderName        ?: boolean,
    placeholderAsOption      ?: boolean,
    optionsWidthAsFieldWidth ?: boolean,
    onApplyOrderChange        : (orderId : number) => void,
}) => (

    makeChain<JSX.Element>()

    // add placeholder option if requested
    .then("orderOptions", (_, next:Link<JSX.Element, Partial<Types.Apis.Models.GalleryOrder>[]>) => {

        // set options from provided orders
        let orderOptions:Partial<Types.Apis.Models.GalleryOrder>[] = orders;
        if (!placeholderAsOption) return next(orderOptions);

        // add placeholder option if requested
        orderOptions.unshift({id: 0});
        return next(orderOptions);

    })

    // create function for formatting the order name
    // format as: {Date} {Job Name} - {#} Photos ({status})
    .then("formatOrderName", (_, next:Link<JSX.Element, (order:Types.Apis.Models.GalleryOrder) => string>) => next((order) => {

        if (order.id === 0) return "Select a Previous Order";

        let orderName = order.jobName
            + " - "
            + order.numImages
            + " Photo"
            + (order.numImages === 1 ? "" : "s")
            + " ("
            + order.status
            + ")";
        if (!useShortOrderName) orderName = (new Date(order.dateCreated)).toLocaleDateString("en-US", {day: '2-digit', month: '2-digit', year: '2-digit'}) + " - " + orderName;
        return orderName;

    }))

    // render the component
    .then(({formatOrderName}) => (
        <Select
            list={orders}
            itemToLabel={v => formatOrderName(v)}
            isSelected={v => v.id === selectedOrderId}
            onChange={v => onApplyOrderChange(v.id)}
            placeholder="Select a Previous Order"
            className="previous-orders-select-l6p"
            captureOutsideClicks={true}
            autoWidth={!optionsWidthAsFieldWidth}
            xdQaName="Previous Order"
        />
    ))

    .run()

);